import { Component } from '@verndale/core';
import { TimelineDefinition, timeline } from 'motion';

class Header extends Component {
  setupDefaults() {
    this.dom = {
      menu: this.el.querySelector('.header__primary-navigation') as HTMLElement,
      menuInner: this.el.querySelector('.header__primary-navigation ul') as HTMLElement,
      openMenu: this.el.querySelector('.header__menu-open') as HTMLElement,
      closeMenu: this.el.querySelector('.header__menu-close') as HTMLElement
    };
  }

  addListeners() {
    (this.dom.openMenu as HTMLButtonElement).addEventListener('click', this.handleOpen.bind(this));
    (this.dom.closeMenu as HTMLButtonElement).addEventListener(
      'click',
      this.handleClose.bind(this)
    );
  }

  handleOpen() {
    (this.dom.menu as HTMLElement).style.display = 'flex';
    const sequence: TimelineDefinition = [
      [this.dom.menu as HTMLElement, { opacity: [0, 1] }, { duration: 0.5 }],
      [this.dom.menuInner as HTMLElement, { x: ['-100%', 0] }, { duration: 1 }]
    ];

    timeline(sequence, { duration: 0.4, defaultOptions: { easing: 'ease-in-out' } });
  }

  handleClose() {
    const sequence: TimelineDefinition = [
      [this.dom.menuInner as HTMLElement, { x: [0, '-100%'] }, { duration: 1 }],
      [this.dom.menu as HTMLElement, { opacity: [1, 0] }, { duration: 0.5 }]
    ];

    timeline(sequence, { duration: 0.4, defaultOptions: { easing: 'ease-in-out' } }).finished.then(
      () => {
        (this.dom.menu as HTMLElement).style.display = '';
        (this.dom.menu as HTMLElement).style.opacity = '';
        (this.dom.menuInner as HTMLElement).style.transform = '';
      }
    );
  }
}

export default Header;
